import { Flex, Tag, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Text } = Typography;

/**
 * The 390px card for one row of a customer-page tab: the document number and
 * its status on top, then a line or two of what it is about. Same shape in
 * every tab, so a phone user reads them all the same way.
 */
export function HistoryCard({
  number,
  status,
  flag,
  lines,
}: {
  number: string;
  status: string;
  /** A second tag, e.g. "Comeback". */
  flag?: string;
  lines: (string | null)[];
}): ReactNode {
  return (
    <Flex vertical gap={2}>
      <Flex justify="space-between" align="center" gap={8} wrap>
        <Text strong>{number}</Text>
        <Flex gap={4}>
          {flag !== undefined && (
            <Tag color="warning" style={{ marginInlineEnd: 0 }}>
              {flag}
            </Tag>
          )}
          <Tag style={{ marginInlineEnd: 0 }}>{status}</Tag>
        </Flex>
      </Flex>
      {lines
        .filter((line): line is string => line !== null && line.length > 0)
        .map((line, index) => (
          // By position: two lines can carry the same text.
          <Text key={index} type="secondary">
            {line}
          </Text>
        ))}
    </Flex>
  );
}
